import React from 'react';
import './CreateAccountGuide.css';
import Breadcrumb from '../../Breadcrumb';

const CreateAccountGuide = () => {
  return (
    <div className='CreateAccountGuide-container'>
            <Breadcrumb current="יצירת חשבון" />

      <h2>איך ליצור חשבון?</h2>
    
    </div>
  );
};

export default CreateAccountGuide;
